<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <form class="o-form -two-columns" @submit.prevent="upsertGeneralSettings(generalSettingsExtended)">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <fieldset class="o-form__inner" v-if="!$apollo.loading">
                <h1 class="o-form__title">Réglages</h1>
                <!-- <pre>{{generalSettingsExtended}}</pre> -->
                <div
                    class="o-form__item"
                    :class="{ 'splitter' : setting.input=='splitter',
                    'spacer' : setting.input=='spacer' }"
                    :key="index"
                    v-for="(setting, index) in generalSettingsExtended"
                >
                    <h2 class="o-form__title" v-if="setting.input=='h2'">{{setting.name}}</h2>
                    <!-- <div v-if="setting.input=='select'">
                    <pre>{{ setting }}</pre>
                    </div> -->
                    <q-item-section v-if="['select', 'text', 'email', 'number'].includes(setting.input)">
                        <Select 
                            v-if="setting.input=='select' && setting.options.multiple"
                            :value="setting.computedValue" 
                            :label="setting.name"
                            :options="setting.values"
                            multiple
                            :clearable="setting.allowNull"
                            :disable="( setting.values.length==0 || (setting.dependsOn && generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0] && !generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0].value) == 1 ? true : false )"
                            :bottom-slots="false"
                            emit-value
                            :ref="setting.key"
                            :filled="false"
                            dense
                            :outlined="true"
                            v-model="setting.computedValue"
                        />
                        <Select 
                            v-else-if="setting.input=='select'"
                            :value="setting.value" 
                            :label="setting.name"
                            :options="setting.values"
                            :clearable="setting.allowNull"
                            @input="setting.value=$event"
                            :disable="( setting.values.length==0 || (setting.dependsOn && generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0] && !generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0].value) == 1 ? true : false )"
                            :bottom-slots="false"
                            emit-value
                            :ref="setting.key"
                            :filled="false"
                            dense
                            :outlined="true"
                        />
                        <Input
                            :suffix="setting.suffix"
                            :prefix="setting.prefix"
                            :type="setting.input"
                            v-if="setting.input=='text' || setting.input=='email'"
                            :value="setting.value" 
                            :label="setting.name"
                            @input="setting.value=$event"
                            :ref="setting.key"
                            :disable="(setting.dependsOn && generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0] && !generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0].value == 1 ? true : false )"
                            :filled="false"
                            dense
                            :outlined="true"
                        />

                        <Input
                            :suffix="setting.suffix"
                            :prefix="setting.prefix"
                            :type="setting.input"
                            v-if="setting.input=='number'"
                            :value="setting.value" 
                            :label="setting.name"
                            @input="setting.value=$event"
                            :ref="setting.key"
                            :disable="(setting.dependsOn && generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0] && !generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0].value == 1 ? true : false )"
                            :filled="false"
                            dense
                            :outlined="true"
                        />
                        
                    </q-item-section>
                    <q-item-section v-if="['select', 'text', 'email', 'number'].includes(setting.input)">
                        <q-item-label class="-setting-description" caption v-html="setting.description"></q-item-label>
                    </q-item-section>
                    <q-item tag="label" v-if="setting.input=='checkbox'">
                        <q-item-section side style="justify-content: start">
                            <q-checkbox 
                                v-if="setting.input=='checkbox'"
                                :value="( setting.value === 'true' || setting.value === '1' || setting.value === true ? true : false )" 
                                :disable="( setting.dependsOn && generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0] && !generalSettingsExtended.filter(obj => obj.key == setting.dependsOn)[0].value ? true : false)"
                                @input="setting.value=$event"
                                size="xs"
                                :bottom-slots="true"
                                emit-value
                                dense
                                :ref="setting.key"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label style="font-size: 12px; font-weight: 600;">{{ setting.name }}</q-item-label>
                            <q-item-label caption v-html="setting.description"></q-item-label>
                        </q-item-section>
                    </q-item>
                    <div v-if="setting.values.length == 0" class="o-error-hint" v-html="setting.errorMSG"></div>
                </div>


                <div class="o-form__item splitter"></div>
                <h2 class="o-form__title">Maintenance</h2>
                <div
                    class="o-form__item"
                >   
                        <q-btn name="rebuild" outline rounded no-caps color="grey" label="Reconstruire l'index"
                            @click.prevent="rebuildIndex()"
                        ></q-btn>
                        <div class="text-caption q-ml-sm q-mt-sm">
                            Recontruire l'index de recherche de projets
                        </div>
                </div>
                <div class="o-form__item -button">
                    <button class="o-button -lg" :loading="$apollo.loading" color="primary">
                        Sauvegarder
                        <q-icon name="save" class="o-ico -right" />
                    </button>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
    import { UPSERTGENERALSETTINGS } from '@/graphql/settings/mutations';
    import { REBUILDPROJECTSINDEX } from '@/graphql/project/mutations';
    import { GENERALSETTINGSEXTENDED, GENERALSETTINGS } from '@/graphql/settings/queries';
    import { isJson } from "@/js/utilities";

    export default {
        name: 'siteSubscription',
        apollo: {
            generalSettingsExtended: {
                query: GENERALSETTINGSEXTENDED,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                update(data) {
                    data.generalSettingsExtended.forEach((item)=>{
                        if(item.options && isJson(item.options)) item.options=JSON.parse(item.options);
                        item.computedValue=[];
                        if (item.options.multiple && item.value?.trim() != "") item.computedValue = item.value?.split(',')
                    })
                    this.$eventBus.$emit('general-settings-updated')
                    return data.generalSettingsExtended
                },

            }
        },

        data(){
            return {
                form: {},
                // settings:  {}
            }
        },
        mounted: function(){
        },
        methods: {
            setThis(value, newValue) {
                if (!newValue) newValue = [];
                let add = [];

                add = newValue.filter(x => !value.includes(x));
                if(add.length==0){
                    value=newValue;
                }else{
                    value.push(add[0])
                    if(add[0]=='-1') return ['-1']
                }

                value=value.filter(o => o!='-1')

                if(value.length==0) return null
                return value.sort();
            },
            msg(str){
                console.log(str);
            },
            rebuildIndex(){
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Réglages", caption: "Reconstruction de l'index en cours..."})
                this.$apollo.mutate({
                    mutation: REBUILDPROJECTSINDEX,
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Réglages", caption: "Index reconstruit"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                })              
            },
            refetchSettings(){
                this.$apollo.query({
                    query: GENERALSETTINGS,
                    fetchPolicy: 'network-only',
                })
                
            },
            async upsertGeneralSettings(generalSettingsExtended){
                let settings=[];
                generalSettingsExtended.forEach(function(setting){
                    if( setting.options.multiple ){
                        setting.value="";
                        if(setting.computedValue) setting.value=setting.computedValue.join(',');
                    }
                    settings.push({
                        key: setting.key,
                        name: setting.name,
                        value: setting.value
                    })
                }.bind(settings))

                await this.$apollo.mutate({
                    mutation: UPSERTGENERALSETTINGS,
                    variables: { 
                        settings : settings
                    }
                }).then(() => {
                    // this.$generalSettings.settings = {};
                    // data.data.upsertGeneralSettings.forEach(function (setting) {
                    //     this.$generalSettings.settings[setting.key] = setting.value
                    // }.bind(this))

                    this.$q.notify({type: 'positive', message: "Réglages", caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                    this.refetchSettings();
                })
            },
        }
    }
</script>
<style lang="scss">
    .o-error-hint {
        color: red;
        margin: 4px 10px;
        font-size: 0.8rem;
        a {
            font-weight: 600;
        }
    }
</style>
